import { render, staticRenderFns } from "./ship-quote.vue?vue&type=template&id=14881f49&scoped=true"
import script from "./ship-quote.vue?vue&type=script&lang=js"
export * from "./ship-quote.vue?vue&type=script&lang=js"
import style1 from "./ship-quote.vue?vue&type=style&index=1&id=14881f49&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14881f49",
  null
  
)

export default component.exports